import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

// configure sentry backend
if(process.env.SENTRY_URL){
  Raven.config(process.env.SENTRY_URL, {
    release: process.env.DEPLOY_HASH,
    environment: process.env.NODE_ENV,
    ignoreUrls: [/localhost/, /local\.euromeal\.com/]
  }).install()
}



// catch unhandled promises (bluebird)
window.onunhandledrejection = function(evt) {
  if(process.env.NODE_ENV !== 'production') console.log(evt)
  Raven.captureException(evt.reason || evt)
}

export {Raven}
export default {
  // handle Vue exceptions
  handleVue(Vue){
    Raven.addPlugin(RavenVue, Vue)
  },

  // handle axios exceptions
  handleAxios(axios){
    axios.interceptors.response.use(null, (error) => {
      let extra

      if(error.config){
        extra = {
          url: error.config.url,
          method: error.config.method,
          params: error.config.params,
          data: JSON.stringify(error.config.data)
        }
      }

      if(error.response){
        extra = extra || {}
        extra.response = error.response.data
      }

      Raven.captureException(error, {
        extra
      })
      throw error
    })
  },


  setUser(user){
    // uses cognito user pool id instead of federated identity id
    Raven.setUserContext({
      id: user.id,
      email: user.email,
      name: user.name
    })
  }
}



// WEBPACK FOOTER //
// ./shared/sentry/client.js